import React, { useState, useEffect } from "react";
import { Input, Card, Button, message } from "antd";
import { useAuth0 } from "@auth0/auth0-react";

// Declare global constants injected by Vite define
declare const API_BASE_URL: string;

export const CacheVersion: React.FC = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [cacheVersion, setCacheVersion] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch current cache version
  const fetchCacheVersion = async () => {
    try {
      const token = await getAccessTokenSilently();
      const response = await fetch(`${API_BASE_URL}/api/admin/cache-version`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch cache version");
      const data = await response.json();
      setCacheVersion(data.version || "");
    } catch (error) {
      message.error("Error fetching cache version.");
    }
  };

  useEffect(() => {
    fetchCacheVersion();
  }, []);

  const handleSaveVersion = async () => {
    setLoading(true);
    try {
      const token = await getAccessTokenSilently();
      const response = await fetch(`${API_BASE_URL}/api/admin/cache-version`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ version: cacheVersion }),
      });

      if (!response.ok) throw new Error("Failed to update cache version");
      message.success("Cache version updated successfully!");
    } catch (error) {
      message.error("Error updating cache version.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Card title="Cache Version Management" style={{ maxWidth: 600 }}>
        <Input
          placeholder="Enter cache version (e.g. V2)"
          value={cacheVersion}
          onChange={(e) => setCacheVersion(e.target.value)}
          style={{ marginBottom: 16 }}
        />
        <Button
          type="primary"
          onClick={handleSaveVersion}
          loading={loading}
        >
          Update Cache Version
        </Button>
      </Card>
    </div>
  );
}; 